export default "__VITE_ASSET__C$UNerQx__"